import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";

const profileImg =
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1000&auto=format&fit=crop";

const Profile = () => {
  return (
    <Box
      component="section"
      sx={{ pt: "40px", pb: "56px", px: { xs: "20px", md: "28px" } }}
    >
      <Box
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: { xs: "40px", md: "60px" },
          alignItems: "center",
        }}
      >
        {/* Image + floating card */}
        <Box sx={{ position: "relative" }}>
          <Box
            component="img"
            src={profileImg}
            alt="Partnership"
            loading="lazy"
            sx={{
              width: "100%",
              height: { xs: "360px", md: "480px" },
              objectFit: "cover",
              borderRadius: "24px",
              transform: "rotate(-1.4deg)",
              boxShadow: "0 36px 70px -34px rgba(14,27,42,.5)",
              display: "block",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "-22px",
              left: { xs: "8px", md: "-20px" },
              background: "#fff",
              borderRadius: "18px",
              p: "18px 22px",
              boxShadow: "0 24px 48px -22px rgba(14,27,42,.45)",
              border: `1px solid ${colors.lineSoft}`,
            }}
          >
            <Box
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "15px",
                color: colors.navyInk,
              }}
            >
              Best-in-class, every engagement
            </Box>
            <Box
              sx={{
                fontFamily: fonts.body,
                fontSize: "13px",
                color: "#7A8896",
                mt: "3px",
              }}
            >
              Experts assembled for your needs
            </Box>
          </Box>
        </Box>

        {/* Text */}
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              OUR PROFILE
            </Box>
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.4vw,42px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            Who we are
          </Box>
          {[
            "Argyle Consulting is a professional consulting firm providing specialist services to resident and non-resident companies in Nigeria, with a growing presence across West Africa and globally through affiliations and collaborations.",
            "We pride ourselves on the highest professional standards, delivering cost-effective, value-based services while promoting partnership and sustainability. Every member of our team is focused on creating value, and this shapes how we set objectives, measure results, and assess our impact.",
            "We make every effort to protect the information our clients and partners entrust us with, because we value and respect their trust.",
          ].map((p, i) => (
            <Box
              key={i}
              sx={{
                fontFamily: fonts.body,
                fontSize: "16px",
                lineHeight: 1.7,
                color: colors.mutedText,
                mt: i === 0 ? "18px" : "14px",
              }}
            >
              {p}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
